import { useNavigate } from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import { useEffect, useCallback, useMemo, useRef, useState } from 'react';
import PATH, { KAKAO_REDIRECT_URI } from '../../../../constants/url';

import { processLogin } from '../../../../assets/js/comm';

import MSG from '../../../../constants/message';

import ToastPopup from '../../../../components/comm/ToastPopup';

const KakaoRedirectPage = () => {
  const navigate = useNavigate();
  const isProcessing = useRef(false);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [sec, setSec] = useState(3);

  const [redirecting, setRedirecting] = useState(false);
  const [baseMsg, setBaseMsg] = useState('');

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  const clearTimers = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    intervalRef.current = null;
    timeoutRef.current = null;
  };

  const startRedirect = (message, seconds = 3) => {
    clearTimers();
    setBaseMsg(message);
    setSec(seconds);
    setToast(true);
    setRedirecting(true);

    intervalRef.current = setInterval(() => {
      setSec((s) => (s > 0 ? s - 1 : 0));
    }, 1000);

    timeoutRef.current = setTimeout(() => {
      navigate(PATH.LANDING, { replace: true });
    }, seconds * 1000);
  };

  useEffect(() => {
    if (redirecting) {
      setToastMessage(`${baseMsg} ${sec}초 후 \n로그인 화면으로 이동합니다.`);
    }
  }, [redirecting, baseMsg, sec]);

  useEffect(() => {
    return () => clearTimers();
  }, []);

  const authCode = useMemo(() => {
    return new window.URL(window.location.href).searchParams.get('code');
  }, []);

  const oauthLogin = useCallback(async (code) => {
    if (isProcessing.current) return;

    isProcessing.current = true;

    try {
      // redirectUri : 토큰 교환 시 authorize 때와 동일한 값이어야 해서 프론트가 그대로 넘긴다
      const res = await axiosApi.post("/oauth/kakao", { code, redirectUri: KAKAO_REDIRECT_URI });

      const tokens = res.data.result.tokens;
      const accessToken = tokens.accessToken;
      const email = tokens.email;
      const nickname = tokens.nickname;
      sessionStorage.setItem('sns_token', accessToken);
      sessionStorage.setItem('sns_email', email);


      await processLogin(accessToken, email, nickname, navigate, startRedirect);

    } catch (err) {
      console.error("api/oauth/kakao 호출 중 오류 : ", err);
      startRedirect(MSG.ERR_PSSUSR+"\n사용자의 "+MSG.ERR_AUTH);
    } finally {
      isProcessing.current = false;
    }
  }, [navigate, startRedirect]);

  useEffect(() => {
    if (authCode) {
      oauthLogin(authCode);
    }
  }, [authCode, oauthLogin]);

  return (
    <>
      <div>로그인 중입니다...</div>
      {toast && (
        <ToastPopup
          setToast={setToast}
          position={"center"}
          message={toastMessage}
        />
      )}
    </>
  );
};

export default KakaoRedirectPage;
